const MRSManager = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Customers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.customers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair'
  },
  {
    title: 'Area Managers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.area-managers.users'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair'
  }
]

const MRSManagerAreaManagers = [
  {
    title: 'Tracking',
    is_heading: true,
    is_active: false,
    link: {
      name: 'audit.area-managers'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Task Events',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.area-managers.events'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-diagram-subtask',
    active_icon: 'fad fa-diagram-subtask'
  },
  {
    title: 'Other Activities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.area-managers.other-events'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree'
  }
]

const MRSManagerReports = [
  {
    title: 'Reports',
    is_heading: true,
    is_active: false,
    link: {
      name: 'audit.reports'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Customers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.reports.customers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair-long',
    active_icon: 'fad fa-user-tie-hair-long'
  },
  {
    title: 'Tasks',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.reports.area-managers-tasks'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-list-check',
    active_icon: 'fad fa-list-check'
  },
  {
    title: 'Other Activities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'audit.reports.area-managers-other-events'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree'
  }
]

export default MRSManager.concat(
  MRSManagerAreaManagers,
  MRSManagerReports
)
